import { Select, SelectProps, Typography } from "antd";

interface Props extends SelectProps {
    label: string
    defaultValue?: string,
    error?: string,
    prefix?: React.ReactNode
}

const SelectBox = ({ defaultValue = "", label, error, prefix, ...rest }: Props) => {
    return (
        <div style={{ width: "100%", position: 'relative' }}>
            <Typography.Text style={{ 
                display: 'block',
                color: "#475569", 
                fontWeight: 500, 
                fontSize: "12px", 
                lineHeight: "1.5", 
                marginBottom: "6px",
                fontFamily: "inherit" 
            }}>
                {label}
            </Typography.Text>
            <div style={{ position: 'relative' }}>
                {prefix && (
                    <div style={{ 
                        position: 'absolute', 
                        left: '12px', 
                        top: '1/2', 
                        zIndex: 1, 
                        display: 'flex', 
                        alignItems: 'center', 
                        height: '100%',
                        color: '#94a3b8'
                    }}>
                        {prefix}
                    </div>
                )}
                <Select
                    defaultValue={defaultValue}
                    size="large"
                    {...rest}
                    style={{ 
                        width: "100%",
                        height: "44px"
                    }}
                    dropdownStyle={{ borderRadius: '12px' }}
                    className={prefix ? "select-with-prefix" : ""}
                />
            </div>
            <style>
                {`
                .select-with-prefix .ant-select-selector {
                    padding-left: 36px !important;
                    border-radius: 12px !important;
                    border-color: #e2e8f0 !important;
                }
                .ant-select-selector {
                    border-radius: 12px !important;
                    border-color: #e2e8f0 !important;
                    height: 44px !important;
                    display: flex !important;
                    align-items: center !important;
                }
                .ant-select-selection-item {
                    font-size: 13px !important;
                    color: #1e293b !important;
                }
                .ant-select-selection-placeholder {
                    font-size: 13px !important;
                    color: #94a3b8 !important;
                }
                `}
            </style>
            {error && (
                <Typography.Text type="danger" style={{ fontSize: '11px', marginTop: '4px', display: 'block' }}>
                    {error}
                </Typography.Text>
            )}
        </div>
    )
}

export default SelectBox;